import { faGem } from '@fortawesome/free-solid-svg-icons';
import SubscriptionsScreen from './SubscriptionsList';
import SubscriptionDetailsScreen from './Subscription';

export type SubscriptionRoutes = Record<
    (
        `w/${string}/subscriptions` |
        `w/${string}/subscription/${string}`
    ),
    RouteProps
>;

const routes: SubscriptionRoutes = {
    'w/:wallet_id/subscriptions': {
        path: 'w/:wallet_id/subscriptions',
        title: 'Subscriptions',
        component: SubscriptionsScreen,
        mainPage: true,
        auth: true,
        exact: true,
        showTab: true,
        icon: faGem,
    },
    'w/:wallet_id/subscription/:subscription_id': {
        path: 'w/:wallet_id/subscription/:plan_id',
        title: 'Subscription',
        component: SubscriptionDetailsScreen,
        auth: true,
        exact: true,
        goBackPath: 'w/:wallet_id/subscriptions'
    },
};

export default routes;
